import parse from 'parse-json';
import { merge } from 'object-path-immutable';
import { utils as commonUtils } from '@sitebuilder/common';
import { highChartOptions } from './GrowthChartWrapper';

export function mergeOptions(
    options: highChartOptions[],
    highChartOptions: Highcharts.Options,
    data: any,
    i18n: any,
    widgetInstanceId: string
) {
    Array.isArray(options) &&
        options.forEach((o) => {
            let userOptions;

            try {
                if (!o.valueType || o.valueType === 'jsonString') {
                    userOptions = parse((o.value as string) || '{}');
                } else {
                    const transformFunctionName = `${widgetInstanceId}-option-${o.path}-transform`;
                    userOptions = commonUtils.transformDataWithGlobals(
                        transformFunctionName,
                        o.functionToTransform,
                        { data, i18n }
                    );
                }
            } catch (error) {
                userOptions = {};
            }

            highChartOptions = merge(highChartOptions, o.path, userOptions);
        });

    return highChartOptions;
}
